<mat-form-field appearance="fill">
  <mat-label [attr.data-test-id]="`${testId()}-label`">{{ label() }}</mat-label>
  <input
    matInput
    placeholder="Search timezone"
    [attr.data-test-id]="testId()"
    [value]="timezoneSearchTerm()"
    [matAutocomplete]="timezoneAutocomplete"
    [errorStateMatcher]="errorStateMatcher"
    (input)="onTimezoneSearch($event)"
    (focus)="onTimezoneInputFocus()"
    (blur)="touch()"
  />
  <mat-autocomplete
    #timezoneAutocomplete="matAutocomplete"
    (optionSelected)="onTimezoneOptionSelected($event)"
    (closed)="onTimezoneAutocompleteClosed()"
  >
    @for (tz of filteredTimezoneOptions(); track tz.value) {
      <mat-option [value]="tz.value" [attr.data-test-id]="`${testId()}-option`">
        {{ tz.label }}
      </mat-option>
    } @empty {
      <mat-option disabled [attr.data-test-id]="`${testId()}-option`">
        No matching timezones
      </mat-option>
    }
  </mat-autocomplete>

  @if (error()) {
    <mat-error [attr.data-test-id]="`${testId()}-error`">{{
      error()
    }}</mat-error>
  } @else if (helperText()) {
    <mat-hint [attr.data-test-id]="`${testId()}-helper-text`">{{
      helperText()
    }}</mat-hint>
  }
</mat-form-field>
